<template>
	<v-menu
		v-model="visible"
		:position-x="position.x"
		:position-y="position.y"
		:nudge-top="nudgeTop"
		class="px-2 py-2"
		ref="v-menu"
	>
		<v-card>
			<div class="px-3 py-3 d-flex post-reaction-add-content relative" ref="v-menu-content">
				<v-overlay
					v-if="saving"
					:value="true"
					absolute
					:dark="false"
					light
					color="white"
					opacity="0.8"
				>
					<v-progress-circular
						indeterminate
						size="30"
					></v-progress-circular>
				</v-overlay>
				<template v-for="(reaction, i) in reactions">
						<v-tooltip top :key="i">
							<template v-slot:activator="{ on }">
								<v-btn
									@click="reaction.action"
									v-on="on"
									:class="['reaction-' + reaction.type, 'mx-2 pa-2 reaction', {'post-reacted': currentReaction && currentReaction.type == reaction.type}]"
									elevation="0"
									:key="i"
									@mouseleave.native="hide"
									@mouseenter.native="show">
									<v-icon class="">{{ reaction.icon }}</v-icon>
								</v-btn>
							</template>
							{{ reaction.tooltip }}
						</v-tooltip>
							<!--
							<wall-action-button
								:action="reaction.action"
								:icon="reaction.icon"
								class="reaction"
								:class="{
									'ml-3': i > 0,
									[ 'post-reacted ' + reaction.background ]: hover || (post && post.my_reaction && post.my_reaction.type == reaction.type)
								}"
								@mouseleave.native="hide"
								@mouseenter.native="show"
								:plain="true"
								:color-on-hover="reaction.color"
							/>
							-->

				</template>
			</div>
		</v-card>
	</v-menu>
</template>

<script>
import {mapActions} from "vuex";
//import WallActionButton from "@/components/items/WallActionButton";

export default {
	name: "PostReactionAdd",
	components: {
		// WallActionButton
	},
	props: {
		post: {
			type: Object,
			default: null
		},
		comment: {
			type: Object,
			default: null
		},
		attach: {
			type: String,
			required: true
		},
		nudgeTop: {
			type: Number,
			default: 0
		},
		problemIdea: {
			type: Object,
			default: null
		},
		postId: {
			type: Number
		},
		message: {
			type: Object,
			default: null
		}

	},
	watch: {
		visible: function (v) {
			if (v)
				this.$nextTick(function () {
					this.calculateCoordinates()
				})
		}
	},
	data () {
		return {
			// like, love, happy, applause
			saving: false,
			visible: false,
			showDelayer: null,
			hideDelayer: null,
			msDelay: 500,
			position: {
				x: 0,
				y: 0
			},
			width: 'auto',
			reactions: [
				{
					icon: '$like',
					type: 'like',
					color: 'success--text',
					background: 'reaction-like',
					action: () => {
						this.submitReaction('like')
					},
					tooltip: this.$vuetify.lang.t('$vuetify.views.wall.post.buttons.reacted.like')
				},
				{
					icon: '$heart-reaction',
					type: 'love',
					color: 'warning--text',
					background: 'reaction-love',
					action: () => {
						this.submitReaction('love')
					},
					tooltip: this.$vuetify.lang.t('$vuetify.views.wall.post.buttons.reacted.love')
				},
				{
					icon: '$face-reaction',
					type: 'happy',
					color: 'gold--text',
					background: 'reaction-happy',
					action: () => {
						this.submitReaction('happy')
					},
					tooltip: this.$vuetify.lang.t('$vuetify.views.wall.post.buttons.reacted.happy')
				},
				{
					icon: '$applause-reaction',
					type: 'applause',
					color: 'blue--text',
					background: 'reaction-applause',
					action: () => {
						this.submitReaction('applause')
					},
					tooltip: this.$vuetify.lang.t('$vuetify.views.wall.post.buttons.reacted.applause')
				}
			]
		}
	},
	computed: {
		currentReaction() {
			if(this.post) {
				return this.post.my_reaction;
			}
			else if(this.comment) {
				return this.comment.my_reaction;
			}
			else if(this.problemIdea) {
				return this.problemIdea.my_reaction;
			}
			else if(this.message) {
				return this.message.my_reaction
			}
			return null;
		},
		reactionable() {
			let r = {
				type: null,
				id: null
			}
			if(this.post) {
				r = {
					type: 'post',
					id: this.post.id
				}
			}
			else if (this.comment) {
				r = {
					type: 'comment',
					id: this.comment.id
				}
			}
			else if (this.problemIdea) {
				r = {
					type: 'problemIdea',
					id: this.problemIdea.id
				}
			}
			else if (this.message) {
				r = {
					type: 'chatMessage',
					id: this.message.id
				}
			}
			return r;
		}
	},
	methods: {
		...mapActions('wall', [
			'setReaction',
			'updateReaction',
			'removeReaction'
		]),
		getReactionText() {
			if(this.comment && this.comment.my_reaction) {
				return this.$vuetify.lang.t('$vuetify.views.wall.post.buttons.reacted.' + this.post.comment.type)
			}
			return this.$vuetify.lang.t('$vuetify.views.wall.post.buttons.reaction')
		},
		test() {
			console.log("TEST!")
		},
		getTypeColor(type) {
			let reaction = this.reactions.find(x => x.type === type)
			return (reaction) ? reaction.background + ' ' + reaction.color : null;
		},
		clearDelayers() {
			if (this.showDelayer) {
				clearTimeout(this.showDelayer)
				this.showDelayer = null
			}
			if (this.hideDelayer) {
				clearTimeout(this.hideDelayer)
				this.hideDelayer = null
			}
		},
		show() {
			this.clearDelayers()
			this.showDelayer = setTimeout(() => {
				this.visible = true
			}, this.msDelay)
		},
		hide() {
			this.clearDelayers()
			this.hideDelayer = setTimeout(() => {
				this.visible = false
			}, this.msDelay)
		},
		async submitReaction(type) {
			this.saving = true;
			let reaction, post = this.post, comment = this.comment, problemIdea = this.problemIdea, message = this.message
			if (this.currentReaction) {
				const id = this.currentReaction.id;
				if(this.currentReaction.type !== type) {
					reaction = await this.updateReaction({type, id})
					if(reaction) {
						if(problemIdea) {
							this.$store.commit('wall/updateReactionToProblemIdea', {
								postID: reaction.post_id,
								problemIdeaId: problemIdea.id,
								reaction})
						}
						else if (post) {
							this.$store.commit('wall/appendReactionToPost',{ post, reaction })
						}
						else if (comment) {
							this.$store.commit('wall/appendReactionToComment',{ comment, reaction })
						}
						else if (message) {
							this.$store.commit('chat/appendReactionToMessage',{ message, reaction })
						}
					}

				}
				else {
					let response = await this.removeReaction({id});
					if(response) {
						if (post) {
							this.$store.commit('wall/removeReactionFromPost',{ post, reaction: this.currentReaction })
						}
						else if (comment) {
							this.$store.commit('wall/removeReactionFromComment',{ comment, reactionID: this.currentReaction.id })
						}
						else if(problemIdea) {
							this.$store.commit('wall/removeReactionFromProblemIdea',{
								postID: this.postId,
								problemIdeaId: problemIdea.id,
								reactionID: id })
						}
						else if (message) {
							this.$store.commit('chat/removeReactionFromMessage',{ message, reaction: this.currentReaction })
						}
					}
					else {
						console.log("ERROR SETTING REACTION")
					}
				}
			}
			else {
				let reactionable_type = this.reactionable.type,
					reactionable_id = this.reactionable.id
				reaction = await this.setReaction({ type, reactionable_type, reactionable_id })

				if(problemIdea) {
					this.$store.commit('wall/appendReactionToProblemIdea', {
						postID: reaction.post_id,
						problemIdeaId: this.problemIdea.id,
						reaction:reaction
					})
				}
				if (reaction && post) {
					this.$store.commit('wall/appendReactionToPost',{ post, reaction })
				}
				else if (reaction && comment) {
					this.$store.commit('wall/appendReactionToComment',{ comment, reaction })
				}
				else if(reaction && message) {
					this.$store.commit('chat/appendReactionToMessage', {message, reaction})
				}
				/*
				else if(reaction && problemIdea) {
					this.$store.commit('wall/appendReactionToComment',{ comment, reaction })
				}
				*/

			}
			this.saving = false;


		},
		/* eslint-disable */
		calculateCoordinates () {
			let parent = document.getElementById(this.attach),
				parentRect = parent.getBoundingClientRect(),
				vmenu = this.$refs['v-menu-content'].parentElement


			// this.position.x = parentRect.left - ((vmenu.clientWidth / 2) - (parent.offsetWidth / 2))
			this.position.x = parentRect.left - ((220 / 2) - (parent.offsetWidth / 2))
			this.position.y = parentRect.top - parentRect.height
		}
		/* eslint-enable */
	},
}
</script>

<style lang="scss">
.post-reaction-add-content {
	.v-btn {
		min-width: 40px !important;
		svg {
			width: 20px;
			height: 20px;
		}
	}
	.post-reacted {
		svg {
			transform: scale(1.2) rotate(-20deg);
			transition: transform 0.5s ease;
		}
		&.success.lighten-3 {
			svg {
				path {
					fill: var(--v-success-base);
				}
			}
		}
	}
}
.reaction {
	transition: all ease 0.4s;
}
.reaction:not(:hover) {
	background-color: var(--v-grey-lighten1) !important;
	&:not(.post-reacted) {
		color: var(--v-grey-base) !important;
	}
}
.post-reacted.reaction-like, .reaction-like {
	background: var(--v-success-lighten3) !important;
	.v-icon {
		color: var(--v-success-base);
	}
	&:hover {
		background: var(--v-success-lighten3) !important;
		.v-icon {
			color: var(--v-success-base) !important;
		}
	}
}
.post-reacted.reaction-love, .reaction-love {
	background-color: $reaction-love-bg !important;
	.v-icon {
		color: var(--v-warning-base)
	}
	&:hover {
		background: $reaction-love-bg !important;
		.v-icon {
			color: var(--v-warning-base) !important
		}
	}
}
.reaction-love-color {
	color: var(--v-warning-base);
}
.post-reacted.reaction-happy, .reaction-happy {
	background: $reaction-happy-bg !important;
	.v-icon {
		color: var(--v-gold-base)
	}
	&:hover {
		background: $reaction-happy-bg !important;
		.v-icon {
			color: var(--v-gold-base) !important;
		}
	}
}
.post-reacted.reaction-applause, .reaction-applause {
	background: $reaction-applause-bg !important;
	.v-icon {
		color: var(--v-blue-base)
	}
	&:hover {
		background: $reaction-applause-bg !important;
		.v-icon {
			color: var(--v-blue-base) !important;
		}
	}
}

//.post-reaction-add {
//
//}
//.post-reaction-add-content {
//	position: relative;
//	&::before {
//		width: 0;
//		height: 0;
//		border-style: solid;
//		border-width: 6px 12px 0 12px; // 12 6
//		border-color: white transparent transparent transparent;
//		position: absolute;
//		bottom: -6px;
//		left: 50%;
//		transform: translateX(-50%);
//		content: "";
//	}
//}
</style>
